import { sessionDataDec } from "../services/sessionServiceEndDec";

export const getDashboardData = () => {
  try {
    return JSON.parse(sessionDataDec('dashboardData') || '{}');
  } catch {
    return {};
  }
};

export const getCardCatArr = () => {
  try {
    return  JSON.parse(sessionDataDec("cardCatArr") || '[]');
  } catch {
    return [];
  }
};
